// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3bqYZ","dragIcon":"Choice_dragIcon__eHosK","left":"Choice_left__3PFjq","input":"Choice_input__fkGd3"};